// ORCA360 - Mobile Workflow Bottom Navigation Bar
// Fixed bottom bar with Back/Next/Skip actions and iOS safe-area padding

import { ChevronLeft, ChevronRight, SkipForward } from 'lucide-react';

interface MobileBottomBarProps {
  onBack?: () => void;
  onNext?: () => void;
  onSkip?: () => void;
  backLabel?: string;
  nextLabel?: string;
  skipLabel?: string;
  nextDisabled?: boolean;
  showBack?: boolean;
  showSkip?: boolean;
  isProcessing?: boolean;
}

export default function MobileBottomBar({
  onBack,
  onNext,
  onSkip,
  backLabel = 'Back',
  nextLabel = 'Next',
  skipLabel = 'Skip',
  nextDisabled = false,
  showBack = true,
  showSkip = false,
  isProcessing = false,
}: MobileBottomBarProps) {
  return (
    <div
      className="fixed bottom-0 left-0 right-0 bg-white border-t border-slate-200 pb-safe z-50"
      style={{ boxShadow: '0 -2px 10px rgba(0,0,0,0.06)' }}
    >
      <div className="flex items-center justify-between px-3 py-1.5 max-w-lg mx-auto">
        {/* Back button */}
        {showBack && onBack ? (
          <button
            onClick={onBack}
            className="flex items-center gap-0.5 px-2.5 py-1.5 text-xs font-medium text-slate-600 rounded-lg hover:bg-slate-100 transition-colors"
          >
            <ChevronLeft size={14} />
            {backLabel}
          </button>
        ) : (
          <div className="w-16" />
        )}

        {/* Skip button (centered) */}
        {showSkip && onSkip && (
          <button
            onClick={onSkip}
            className="flex items-center gap-0.5 px-2 py-1 text-[10px] font-medium text-slate-400 rounded-md hover:bg-slate-50 transition-colors"
          >
            <SkipForward size={12} />
            {skipLabel}
          </button>
        )}

        {/* Next button */}
        <button
          onClick={onNext}
          disabled={nextDisabled || isProcessing}
          className={`flex items-center gap-0.5 px-4 py-1.5 text-xs font-semibold text-white rounded-lg transition-all ${
            nextDisabled || isProcessing ? 'bg-slate-400 cursor-not-allowed' : 'bg-navy cursor-pointer'
          }`}
        >
          {isProcessing ? (
            <>
              <div className="w-3 h-3 border-2 border-white/30 border-t-white rounded-full animate-spin" />
              Processing...
            </>
          ) : (
            <>
              {nextLabel}
              <ChevronRight size={14} />
            </>
          )}
        </button>
      </div>
    </div>
  );
}
